import {configureStore} from "@reduxjs/toolkit";
import challengesReducer from "./ChallengeDataSlice"; // Import your slice
import planSectionReducer from "./PlanSectionSlice"; // Import your slice

const store = configureStore({
  reducer: {
    challengesData: challengesReducer,
    planSection: planSectionReducer,
  },
});

export default store;
